import React from 'react';
import PropTypes from 'prop-types';
import { connectDeep } from 'redux-utils';

import ContinueInstallModal, {
  dispatchToProps as installDispatch,
  stateToProps as installState
} from './ContinueInstallModal';
import ErrorModal, {
  dispatchToProps as errorDispatch,
  stateToProps as errorState
} from './ErrorModal';

const ModalSwitcher = ({ error, errorDispatch, install, installDispatch }) => {
  if (
    error &&
    ((error.message && error.title) || (error.messageKey && error.titleKey))
  ) {
    return <ErrorModal error={error} {...errorDispatch} />;
  } else if (install.continueInstall.show) {
    return <ContinueInstallModal {...install} {...installDispatch} />;
  }
  return <div />;
};

ModalSwitcher.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
    title: PropTypes.string
  }),
  install: PropTypes.shape({
    installFlow: PropTypes.shape({
      requiresWifi: PropTypes.bool
    }),
    continueInstall: PropTypes.shape({
      show: PropTypes.bool,
      hasBeenSeen: PropTypes.bool,
      shouldContinue: PropTypes.bool
    })
  }).isRequired,
  errorDispatch: PropTypes.shape({
    removeError: PropTypes.func.isRequired
  }).isRequired,
  installDispatch: PropTypes.shape({
    triggerSync: PropTypes.func.isRequired,
    triggerRemove: PropTypes.func.isRequired
  }).isRequired
};

const mapStateToProps = ({
  gallery: { triggerError },
  installFlow: { continueInstall, requiresWifi }
}) => ({
  ...errorState({ triggerError }),
  install: {
    ...installState({ continueInstall, requiresWifi })
  }
});

const mapDispatchToProps = (dispatch) => ({
  errorDispatch: {
    ...errorDispatch(dispatch)
  },
  installDispatch: {
    ...installDispatch(dispatch)
  }
});

export default connectDeep(mapStateToProps, mapDispatchToProps)(ModalSwitcher);
